"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressValidationResult = void 0;
var AddressValidationResult;
(function (AddressValidationResult) {
    AddressValidationResult["VALID_ADDRESS"] = "VALID_ADDRESS";
    AddressValidationResult["MISSING_UNIT_NUMBER"] = "MISSING_UNIT_NUMBER";
    AddressValidationResult["CORRECTED_ADDRESS"] = "CORRECTED_ADDRESS";
    AddressValidationResult["INVALID_ADDRESS"] = "INVALID_ADDRESS";
})(AddressValidationResult || (exports.AddressValidationResult = AddressValidationResult = {}));
